import { MessageCircle } from 'lucide-react';
import { WHATSAPP_URL } from '../constants';

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-button"
      aria-label="Falar pelo WhatsApp"
      className="fixed bottom-6 right-6 z-50 flex items-center gap-2 bg-[#25D366] text-white font-poppins font-semibold text-sm px-5 py-3.5 rounded-full shadow-2xl hover:bg-[#1da851] hover:-translate-y-1 transition-all duration-200 group"
    >
      <MessageCircle size={20} />
      <span className="hidden sm:inline">Falar pelo WhatsApp</span>
    </a>
  );
}
